import React from 'react';
import HelpAsk from '../help/HelpAsk';
import { HelpOffer } from '../help/HelpOffer';

interface ConfirmationModalProps {
    show: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    isDeleting?: boolean;
    /** Hide the cancel button to use this dialog as an info-only acknowledgement
     *  (e.g. surfacing a guard-rail block where the user has no choice but to
     *  acknowledge and close). */
    hideCancel?: boolean;
    /** A How To to offer under the message — used where this dialog reports a
     *  guard-rail block and there is a guide for clearing it. */
    help?: HelpOffer | null;
    zIndex?: number;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = "Delete",
    cancelText = "Cancel",
    isDeleting = false,
    hideCancel = false,
    help = null,
    zIndex,
}) => {
    if (!show) return null;

    return (
        <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)', ...(zIndex != null ? { zIndex } : {}) }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content ivory-panel">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onCancel}></button>
                    </div>
                    <div className="modal-body">
                        <p style={{ whiteSpace: 'pre-line', margin: 0 }}>{message}</p>
                        {help && (
                            <div className="mt-2">
                                <HelpAsk guideKey={help.guideKey} label={help.label} variant="inline" />
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        {!hideCancel && (
                            <button type="button" className="btn btn-secondary" onClick={onCancel}>
                                {cancelText}
                            </button>
                        )}
                        <button
                            type="button"
                            className={`btn ${isDeleting ? 'btn-danger' : 'btn-primary'}`}
                            onClick={onConfirm}
                        >
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
